"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ContactForm_1 = require("./partials/ContactForm");
const SideBar_1 = require("./SideBar");
const fluxible_addons_react_1 = require("fluxible-addons-react");
const ApplicationStore_1 = require("../stores/ApplicationStore");
class About extends React.Component {
    render() {
        return (React.createElement("div", null,
            React.createElement("section", { className: 'blog-heading text-center', style: { backgroundImage: 'url("' + this.props.picUrl + '")' } },
                React.createElement("div", { className: 'container' },
                    React.createElement("h1", { className: 'text-uppercase' }, "Contact"),
                    React.createElement("div", { className: 'desc' },
                        React.createElement("p", null, "Don't be shy to send me a message")))),
            React.createElement("section", { className: 'blog-content blog-standard' },
                React.createElement("div", { className: 'container' },
                    React.createElement("div", { className: 'row' },
                        React.createElement("div", { className: 'col-md-9' },
                            React.createElement("div", { className: 'content' },
                                React.createElement("div", { className: 'post' },
                                    React.createElement("div", { className: 'post-body' },
                                        React.createElement("div", { className: 'post-entry', dangerouslySetInnerHTML: { __html: this.props.text } }),
                                        React.createElement("div", { className: 'contact-form' },
                                            React.createElement(ContactForm_1.default, null)))))),
                        React.createElement(SideBar_1.default, null))))));
    }
}
class AboutProps {
}
exports.default = (0, fluxible_addons_react_1.connectToStores)(About, [ApplicationStore_1.default], (context, props) => {
    const appStore = context.getStore(ApplicationStore_1.default);
    return {
        text: appStore.getParam('about_text'),
        picUrl: appStore.getParam('about_picUrl'),
    };
});
